import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "./firebase";

export const FEATURE_FLAGS = {
  APP_UNDER_MAINTENANCE: "APP_UNDER_MAINTENANCE",
  APP_UNDER_MAINTENANCE_PLACEHOLDER: "APP_UNDER_MAINTENANCE_PLACEHOLDER",
};

export const fetchFeatureFlag = async (flagKey) => {
  try {
    remoteConfig.settings.minimumFetchIntervalMillis = 300000; // 5 min
    await fetchAndActivate(remoteConfig);
    const flagValue = getValue(remoteConfig, FEATURE_FLAGS[flagKey]).asString();
    return flagValue;
  } catch (error) {
    return null;
  }
};
